// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__jUi2C","info":"Panel_info__aTAca","btns":"Panel_btns__2K2PF","button":"Panel_button__wRhrp"};